var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"error-423"},[_c('div',{staticClass:"error-423__message"},[_vm._v("423エラーが発生しました。リソースがロックされています。")]),_c('a',{staticClass:"error-423__link",attrs:{"href":_vm.returnPage}},[_vm._v("戻る")])])
}
var staticRenderFns = []

export { render, staticRenderFns }